import React from 'react';
import DivisorForm from './DivisorForm';

interface Document {
  id: number;
  name: string;
  divisor_types?: string[];
}

interface ExtractJob {
  id: number;
  job_id: string;
  name?: string;
}

interface ParentDivisor { id: number; title: string; }

interface DivisorNewProps {
  document: Document;
  extractJob: ExtractJob;
  parentDivisors: ParentDivisor[];
  errors: Record<string, string[]>;
  /** Canonical list from server (DivisorType.all_types) */
  divisorTypes?: string[];
}

export default function DivisorNew({
  document,
  extractJob,
  parentDivisors,
  errors,
  divisorTypes
}: DivisorNewProps) {
  // For "new", give DivisorForm an empty divisor object
  const emptyDivisor = {
    divisor_type: '',
    title: '',
    content_preview: '',
    parent_id: undefined as number | undefined,
    metadata: undefined as unknown
  };

  // Always provide a safe, normalized list
  const safeDivisorTypes: string[] = (divisorTypes ?? document.divisor_types ?? []).map(String);

  return (
    <DivisorForm
      document={document}
      extractJob={extractJob}
      divisor={emptyDivisor}
      parentDivisors={parentDivisors}
      isEdit={false}
      errors={errors}
      divisorTypes={safeDivisorTypes}
    />
  );
}
